import React from 'react';
import classNameBind from 'classnames/bind';
import ActionList from '../../ActionList';
import { useBlur } from '../../../hooks/useBlur';
import getScrollbarWidth from '../../../utils/methods/getScrollbarWidth';
import styles from './TimeSelector.module.css';
import { hours12Options, hours24Options, minutesOptions, periodOptions, Periods } from './options';

const bindClasses = classNameBind.bind(styles);

const TimeSelector = ({ value, onChange, onBlur, dataId, is12HourFormat, fixedHeight } = {}) => {
  const { ref, handleBlur } = useBlur({ disabled: false, value, onBlur });
  // eslint-disable-next-line no-nested-ternary
  const currentPeriod = value ? (value.getHours() - 12 >= 0 ? Periods.PM : Periods.AM) : null;
  const hoursOptions = is12HourFormat ? hours12Options : hours24Options;
  const scrollbarWidth = getScrollbarWidth();

  const handlePeriodChange = (option) => {
    const newValue = new Date(value);
    const hours = newValue.getHours();

    if (currentPeriod !== option.value) {
      newValue.setHours(option.value === Periods.AM ? hours - 12 : hours + 12);
    }

    onChange({
      target: {
        value: newValue,
      },
    });
  };

  const handleMinutesChange = (option) => {
    const newValue = new Date(value);

    newValue.setMinutes(option.value);

    onChange({
      target: {
        value: newValue,
      },
    });
  };

  const handleHoursChange = (option) => {
    const newValue = new Date(value);

    if (is12HourFormat) {
      const isPM = value ? (value.getHours() - 12 >= 0) : false;

      if (isPM) {
        newValue.setHours(option.value + 12);
      } else {
        newValue.setHours(option.value);
      }
    } else {
      newValue.setHours(option.value);
    }

    onChange({
      target: {
        value: newValue,
      },
    });
  };

  return (
    <div
      className={bindClasses('wrapper', { fixedHeight })}
      ref={ref}
      onBlur={handleBlur}
    >
      <div className={bindClasses('section')}>
        <div className={bindClasses('section-scroll')} style={{ paddingLeft: `${scrollbarWidth}px` }}>
          <ActionList
            groups={[{
              id: 0,
              name: '',
              items: hoursOptions,
            }]}
            onItemSelected={handleHoursChange}
            dataId={`${dataId}.hours`}
            current={value ? (is12HourFormat ? value.getHours() % 12 : value.getHours()).toString() : null}
            centerContent
            hoverStyle="calendar"
          />
        </div>
      </div>
      <div className={bindClasses('section')}>
        <div className={bindClasses('section-scroll')} style={{ paddingLeft: `${scrollbarWidth}px` }}>
          <ActionList
            groups={[{
              id: 0,
              name: '',
              items: minutesOptions,
            }]}
            onItemSelected={handleMinutesChange}
            dataId={`${dataId}.minutes`}
            current={value ? value.getMinutes().toString() : null}
            centerContent
            hoverStyle="calendar"
          />
        </div>
      </div>
      {is12HourFormat && (
        <div className={bindClasses('section')}>
          <div className={bindClasses('section-scroll')}>
            <ActionList
              groups={[{
                id: 0,
                name: '',
                items: periodOptions,
              }]}
              onItemSelected={handlePeriodChange}
              dataId={`${dataId}.period`}
              current={currentPeriod}
              centerContent
              hoverStyle="calendar"
            />
          </div>
        </div>
      )}
    </div>
  );
};

TimeSelector.defaultProps = {
  onBlur: () => {},
  dataId: 'TimeSelector',
};

export { TimeSelector };
